export default {
  // for app header component
  'appHeader.verantosLogo.alt': 'Verantos',
  'appHeader.platform.name': 'Evidence Platform',
  'appHeader.platform.name.internal': 'Internal Platform',
  'appHeader.platform.name.curation': 'Curation Platform',
  'appHeader.userMenu.accountSettings': 'Account',
  'appHeader.userMenu.helpSupport': 'Help & support',
  'appHeader.userMenu.logout': 'Log out',

  // app header accout dialog
  'appHeader.accountDialog.title': 'Account',
  'appHeader.accountDialog.label.fullName': 'Full name',
  'appHeader.accountDialog.label.email': 'Email address',
  'appHeader.accountDialog.label.roles': 'Role(s)',
  'appHeader.accountDialog.label.organization': 'Organization',

  'appHeader.accountDialog.label.resetPassword': 'Reset password',

  // confirm dialog
  'appHeader.confirmLogoutDialog.title': 'Log out',
  'appHeader.confirmLogoutDialog.message.title': 'Confirm log out',
  'appHeader.confirmLogoutDialog.message':
    'Logging out will end your session. Any unsaved changes will be lost.',
  'appHeader.confirmLogoutDialog.cancelButton.label': 'Cancel',
  'appHeader.confirmLogoutDialog.saveButton.label': 'Log out',
};
